import { gestaoApi } from "../services/api";

export async function fetchEvento(props) {
  const { idEvento } = props;

  const res = await gestaoApi.get(`evento/${idEvento}`);
  const data = res.data;
  return data;
}
